<template>
  <b-col :xl="content.columns" cols="12">
    <div class="card">
      <LmComponentLoading v-if="loading"/>
      <div class="card-body">
        <a href="" class="d-none btn btn-sm btn-link float-right mb-3">Export
          <i class="mdi mdi-download ml-1"></i>
        </a>
        <h4 v-if="content.tableTitle" class="header-title mt-2">{{ content.tableTitle }}</h4>

        <div class="table-responsive">
          <table class="table table-centered table-hover mb-0" :class="{'hide-headers-below-rows': hideHeadersBelowRows}">
            <thead v-if="showHeaderTable">
              <tr>
                  <th v-for="(objContent, key) in content.rows[0]" :key="`${key}-key`">
                    <template v-if="objContent.humanName">
                      {{keyReadableForHuman(objContent.humanName)}}
                    </template>
                    <template v-else>
                      {{ key.toLowerCase() === 'lmactions' ? 'Acciones' : keyReadableForHuman(key)}}
                    </template>
                  </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(tr, index) in content.rows" :key="index">
                <td v-for="(objContent, key, index) in tr" :key="index">
                  <div v-if="key === 'lmActions'">
                    <template v-if="typeof objContent === 'object' && objContent !== null && !Array.isArray(objContent)">
                      <router-link
                        v-for="(option, name, index) in objContent.content" :key="index"
                        :to="option.path"
                        :title="option.title"
                        class="p-1 d-inline-block">
                        <font-awesome-icon
                          :icon="option.icon"
                          size="lg"
                          class="clickable"
                          />
                      </router-link>
                    </template>
                    <template v-else>
                      <router-link
                        v-for="(option, name, index) in objContent" :key="index"
                        :to="option.path"
                        :title="option.title"
                        class="p-1 d-inline-block">
                        <font-awesome-icon
                          :icon="option.icon"
                          size="lg"
                          class="clickable"
                          />
                      </router-link>
                    </template>
                  </div>
                  <h5 v-else class="font-14 mb-1 font-weight-normal">
                    <template v-if="typeof objContent === 'object' && objContent !== null">
                      {{ objContent.content }}
                    </template>
                    <template v-else>
                      {{ objContent }}
                    </template>
                  </h5>
                  <span v-if="key !== 'lmActions' && !hideHeadersBelowRows" class="text-muted font-13">
                    <template v-if="objContent.length">
                      {{ keyReadableForHuman(key) }}
                    </template>
                    <template v-else>
                      {{ keyReadableForHuman(objContent.humanName) }}
                    </template>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div> <!-- end table-responsive-->
      </div> <!-- end card-body-->
    </div> <!-- end card-->
  </b-col>
</template>

<script>
import { mapState } from 'vuex'
import keyReadableForHuman from '@/helpers/key-readable-for-humans.js'
export default {
  props: {
    content: {
      type: [Array, Object],
      default: () => []
    },
    showHeaderTable: {
      type: Boolean,
      default: false
    },
    hideHeadersBelowRows: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    keyReadableForHuman (key) {
      return keyReadableForHuman(key)
    }
  },
  computed: {
    ...mapState('settings', ['loading'])
  }
}
</script>

<style lang="sass" scoped>
  .table-hover
    tbody
      tr
        &:hover
          background: #f1f3fa
  .table
    td,
    th
      padding: 15px
      &::first-letter
        text-transform: capitalize
    td
      span
        display: block
        text-transform: lowercase
        &::first-letter
          text-transform: capitalize
    &.hide-headers-below-rows
      td,
      th
        padding: 5px
</style>
